import * as React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <g>
    <path
      transform="scale(1.2)"
      xmlns="http://www.w3.org/2000/svg"
      d="M2.5 5.33335L3.66667 4.16669L7.70833 8.18752C8.02778 8.50696 8.38889 8.75002 8.79167 8.91669C9.19444 9.08335 9.61806 9.16669 10.0625 9.16669H14.3125L13 7.83335L14.1667 6.66669L17.5 10L14.1667 13.3334L13 12.1667L14.3125 10.8334H10.0625C9.61806 10.8334 9.19444 10.9167 8.79167 11.0834C8.38889 11.25 8.02778 11.4931 7.70833 11.8125L3.66667 15.8334L2.5 14.6667L7.16667 10L2.5 5.33335Z"
    />
  </g>,
  "AcUnit"
);
